<template>
    <div class="login-future-page">
        <div class="login-future-page__grid"></div>
        <div class="login-future-page__scanline"></div>
        <div class="login-future-page__ambient login-future-page__ambient--primary"></div>
        <div class="login-future-page__ambient login-future-page__ambient--secondary"></div>
        <div class="login-future-page__ambient login-future-page__ambient--accent"></div>

        <div class="login-future-page__shell">
            <div class="login-future-page__panel">
                <section class="login-future-page__story">

                    <div class="login-future-page__story-copy">
                        <h1>{{ $t('login_command_center') }}</h1>
                        <p>{{ $t('login_command_center_subtitle') }}</p>
                    </div>

                    <div class="login-future-page__visual">
                        <div class="login-future-page__visual-grid"></div>

                        <div class="login-future-page__visual-module login-future-page__visual-module--incident">
                            <div class="login-future-page__visual-module-head">
                                <span class="login-future-page__visual-module-icon">
                                    <i class="fa fa-exclamation-triangle"></i>
                                </span>
                                <div class="login-future-page__visual-module-copy">
                                    <span>{{ $t('incident') }}</span>
                                    <strong>{{ $t('login_story_incident_status') }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="login-future-page__visual-device">
                            <div class="login-future-page__visual-device-head">
                                <span class="login-future-page__visual-device-icon">
                                    <i class="fa fa-tablet"></i>
                                </span>
                                <div class="login-future-page__visual-device-copy">
                                    <span>{{ $t('device') }}</span>
                                    <strong>{{ $t('login_story_device_status') }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="login-future-page__visual-route">
                            <span class="login-future-page__visual-route-pin login-future-page__visual-route-pin--origin">
                                <i class="fa fa-map-marker"></i>
                            </span>
                            <span class="login-future-page__visual-route-label login-future-page__visual-route-label--origin">
                                {{ $t('origin') }}
                            </span>
                            <span class="login-future-page__visual-route-pin login-future-page__visual-route-pin--destination">
                                <i class="fa fa-map-marker"></i>
                            </span>
                            <span class="login-future-page__visual-route-label login-future-page__visual-route-label--destination">
                                {{ $t('destination') }}
                            </span>

                            <div class="login-future-page__visual-truck">
                                <span class="login-future-page__visual-truck-signal"></span>
                                <span class="login-future-page__visual-truck-signal login-future-page__visual-truck-signal--delay"></span>
                                <span class="login-future-page__visual-truck-icon">
                                    <img :src="urlGenerator('/images/delivery-truck.png')"
                                         :alt="$t('vehicule_type')"
                                         class="login-future-page__visual-truck-image" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="login-future-page__story-note">
                        <span class="login-future-page__story-note-kicker">
                            <app-icon name="map" class="login-future-page__story-note-icon" />
                            {{ $t('login_story_route_visibility') }}
                        </span>
                        <strong>{{ $t('login_story_route_visibility_title') }}</strong>
                        <p>{{ $t('login_story_route_visibility_copy') }}</p>
                    </div>

                </section>

                <section class="login-future-page__auth">
                    <div class="login-future-page__auth-inner">
                        <div class="login-future-page__auth-header">
                            <div class="login-future-page__brand-lockup">
                                <div class="login-future-page__logo-wrap">
                                    <img :src="companyLogo" :alt="companyName" class="login-future-page__logo" />
                                </div>

                                <div class="login-future-page__brand-copy">
                                    <span class="login-future-page__company">{{ companyName }}</span>
                                    <!-- <div class="login-future-page__eyebrow">
                                        <span class="login-future-page__eyebrow-dot"></span>
                                        {{ $t('login_story_kicker') }}
                                    </div> -->
                                </div>
                            </div>
                        </div>

                        <div class="login-future-page__auth-copy">
                            <!-- <h2>{{ $t('login_sign_in_continue') }}</h2> -->
                            <p>{{ $t('login_form_hint') }}</p>
                        </div>

                        <form class="sign-in-sign-up-form login-future-page__form"
                              ref="form"
                              data-url="/admin/users/login"
                              action="store"
                              @submit.prevent="submit">
                            <div class="form-row">
                                <div class="form-group col-12 px-0 login-future-page__field">
                                    <label for="login_email" class="login-future-page__label">
                                        <app-icon name="mail" class="mr-2" />
                                        {{ $t('login_identifier') }}
                                    </label>
                                    <app-input id="login_email"
                                               type="email"
                                               v-model="login.email"
                                               input-class="login-future-page__input-control"
                                               :placeholder="$t('enter_your_identifier')"
                                               :required="true"
                                               autocomplete="username"/>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-12 px-0 login-future-page__field">
                                    <label for="login_password" class="login-future-page__label">
                                        <app-icon name="lock" class="mr-2" />
                                        {{ $t('password') }}
                                    </label>
                                    <app-input id="login_password"
                                               type="password"
                                               v-model="login.password"
                                               input-class="login-future-page__input-control"
                                               :placeholder="$t('enter_your_password')"
                                               :required="true"
                                               :show-password="true"
                                               autocomplete="current-password"/>
                                </div>
                            </div>

                            <div class="form-row" v-if="recaptchaEnable == 1">
                                <div class="form-group col-12 px-0 login-future-page__recaptcha">
                                    <re-captcha :site-key="siteKey"></re-captcha>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-12 px-0 mb-0">
                                    <app-load-more :preloader="preloader"
                                                   :label="$t('login')"
                                                   type="submit"
                                                   class-name="btn btn-primary btn-block text-center login-future-page__submit"
                                                   @submit="submit"/>
                                </div>
                            </div>
                        </form>

                        <p class="login-future-page__copyright">
                            {{ $t('copyright_text') + companyName }}
                        </p>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "Login",
        mixins: [AuthMixin, ThemeMixin],
        components: {},
        props: {
            siteKey: String,
            recaptchaEnable: {},
        },
        data() {
            return {
                urlGenerator,
                login: {email: '', password: ''},
            };
        },
        computed: {
            companyLogo() {
                return this.configData && this.configData.company_logo
                    ? this.urlGenerator(this.configData.company_logo)
                    : this.urlGenerator('/images/core.png');
            },
            companyName() {
                return this.configData && this.configData.company_name
                    ? this.configData.company_name
                    : 'Escort';
            },
        },
        methods: {
            submit() {
                this.save(this.login);
            },
            afterSuccess(res) {
                window.location = res.data;
            }
        }
    }
</script>

<style>
.login-future-page {
    --login-bg-top: #fbfcfe;
    --login-bg-mid: #f4f7fb;
    --login-bg-bottom: #edf2f7;
    --login-grid-line: rgba(15, 23, 42, 0.04);
    --login-panel-border: rgba(15, 23, 42, 0.07);
    --login-panel-border-strong: rgba(var(--brand-primary-rgb), 0.12);
    --login-panel-bg: rgba(255, 255, 255, 0.88);
    --login-panel-bg-strong: rgba(255, 255, 255, 0.97);
    --login-panel-bg-soft: rgba(247, 249, 252, 0.94);
    --login-surface: rgba(255, 255, 255, 0.92);
    --login-surface-soft: rgba(247, 249, 252, 0.92);
    --login-brand-soft: rgba(var(--brand-primary-rgb), 0.06);
    --login-brand-soft-strong: rgba(var(--brand-primary-rgb), 0.12);
    --login-ink: #112033;
    --login-ink-soft: #20324a;
    --login-muted: #697b91;
    --login-muted-strong: #4e6278;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    height: 100vh;
    padding: clamp(1.5rem, 4vw, 3rem);
    overflow: hidden;
    background:
        radial-gradient(circle at 14% 14%, rgba(var(--brand-primary-rgb), 0.11), transparent 24%),
        radial-gradient(circle at 86% 14%, rgba(var(--brand-primary-rgb), 0.06), transparent 22%),
        linear-gradient(145deg, var(--login-bg-top) 0%, var(--login-bg-mid) 48%, var(--login-bg-bottom) 100%);
    color: var(--login-ink);
    isolation: isolate;
}

[theme='dark'] .login-future-page {
    --login-bg-top: #07111d;
    --login-bg-mid: #0d1724;
    --login-bg-bottom: #121d2d;
    --login-grid-line: rgba(148, 163, 184, 0.08);
    --login-panel-border: rgba(148, 163, 184, 0.16);
    --login-panel-border-strong: rgba(var(--brand-primary-rgb), 0.24);
    --login-panel-bg: rgba(9, 17, 29, 0.9);
    --login-panel-bg-strong: rgba(9, 17, 29, 0.96);
    --login-panel-bg-soft: rgba(15, 23, 42, 0.88);
    --login-surface: rgba(15, 23, 42, 0.84);
    --login-surface-soft: rgba(30, 41, 59, 0.82);
    --login-brand-soft: rgba(var(--brand-primary-rgb), 0.12);
    --login-brand-soft-strong: rgba(var(--brand-primary-rgb), 0.24);
    --login-ink: #eef4fb;
    --login-ink-soft: #f8fbff;
    --login-muted: #9dafc5;
    --login-muted-strong: #ccd8e6;
}

[theme='dark'] .login-future-page__scanline {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), transparent 24%);
    opacity: 0.14;
}

[theme='dark'] .login-future-page__panel {
    background:
        linear-gradient(180deg, rgba(15, 23, 42, 0.92), var(--login-panel-bg-soft)),
        var(--login-panel-bg);
}

[theme='dark'] .login-future-page__story {
    background:
        linear-gradient(180deg, rgba(15, 23, 42, 0.96), rgba(15, 23, 42, 0.9)),
        radial-gradient(circle at top left, var(--login-brand-soft), transparent 34%);
}

[theme='dark'] .login-future-page__story::after {
    background: radial-gradient(circle, rgba(var(--brand-primary-rgb), 0.16), transparent 72%);
}

[theme='dark'] .login-future-page__auth {
    background:
        linear-gradient(180deg, rgba(9, 17, 29, 0.985), rgba(15, 23, 42, 0.96)),
        var(--login-panel-bg-strong);
}

[theme='dark'] .login-future-page__logo-wrap {
    background: linear-gradient(135deg, rgba(15, 23, 42, 0.98), rgba(30, 41, 59, 0.92));
}

[theme='dark'] .login-future-page__eyebrow {
    background: rgba(15, 23, 42, 0.78);
}

[theme='dark'] .login-future-page__visual {
    background:
        radial-gradient(circle at 78% 18%, rgba(var(--brand-primary-rgb), 0.12), transparent 24%),
        linear-gradient(180deg, rgba(15, 23, 42, 0.96), rgba(15, 23, 42, 0.92)),
        rgba(9, 17, 29, 0.94);
}

[theme='dark'] .login-future-page__visual-grid {
    background-image:
        linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),
        linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
}

[theme='dark'] .login-future-page__story-note {
    background: linear-gradient(180deg, rgba(15, 23, 42, 0.92), rgba(var(--brand-primary-rgb), 0.1));
}

[theme='dark'] .login-future-page__visual-module--incident {
    background: linear-gradient(180deg, rgba(64, 39, 6, 0.96), rgba(78, 47, 8, 0.92));
}

[theme='dark'] .login-future-page__visual-device {
    background:
        linear-gradient(180deg, rgba(8, 46, 25, 0.96), rgba(9, 58, 31, 0.92)),
        rgba(15, 23, 42, 0.9);
}

[theme='dark'] .login-future-page__visual-route::after {
    background-image: linear-gradient(90deg, rgba(203, 213, 225, 0.34) 45%, transparent 45%);
}

[theme='dark'] .login-future-page__visual-route-pin {
    background: rgba(15, 23, 42, 0.98);
    border-color: rgba(var(--brand-primary-rgb), 0.28);
}

[theme='dark'] .login-future-page__visual-route-pin--origin {
    border-color: rgba(148, 163, 184, 0.28);
    background: rgba(30, 41, 59, 0.96);
    color: #94a3b8;
}

[theme='dark'] .login-future-page__visual-route-pin--destination {
    border-color: rgba(34, 197, 94, 0.3);
    background: rgba(8, 46, 25, 0.96);
}

[theme='dark'] .login-future-page .form-control.login-future-page__input-control {
    border-color: rgba(148, 163, 184, 0.22) !important;
    background: rgba(15, 23, 42, 0.84) !important;
}

[theme='dark'] .login-future-page .form-control.login-future-page__input-control::placeholder,
[theme='dark'] .login-future-page .form-group-with-icon .form-control-feedback {
    color: rgba(203, 213, 225, 0.58);
}

[theme='dark'] .login-future-page .form-control.login-future-page__input-control:focus {
    background: rgba(15, 23, 42, 0.96) !important;
}

.login-future-page__grid,
.login-future-page__scanline,
.login-future-page__ambient {
    position: absolute;
    inset: 0;
    pointer-events: none;
}

.login-future-page__grid {
    background-image:
        linear-gradient(var(--login-grid-line) 1px, transparent 1px),
        linear-gradient(90deg, var(--login-grid-line) 1px, transparent 1px);
    background-size: 4rem 4rem;
    mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.22), transparent 88%);
    animation: loginFutureGridShift 18s linear infinite;
}

.login-future-page__scanline {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.28), transparent 24%);
    opacity: 0.08;
}

.login-future-page__ambient {
    filter: blur(24px);
    opacity: 0.5;
}

.login-future-page__ambient--primary {
    inset: auto auto 12% 12%;
    width: 16rem;
    height: 16rem;
    border-radius: 50%;
    background: rgba(var(--brand-primary-rgb), 0.1);
    animation: loginFutureFloatOne 9s ease-in-out infinite;
}

.login-future-page__ambient--secondary {
    inset: 10% 10% auto auto;
    width: 12rem;
    height: 12rem;
    border-radius: 50%;
    background: rgba(var(--brand-primary-rgb), 0.08);
    animation: loginFutureFloatTwo 10s ease-in-out infinite;
}

.login-future-page__ambient--accent {
    inset: auto 24% 16% auto;
    width: 9rem;
    height: 9rem;
    border-radius: 50%;
    background: rgba(148, 163, 184, 0.12);
    animation: loginFuturePulse 6s ease-in-out infinite;
}

.login-future-page__shell {
    position: relative;
    z-index: 1;
    width: min(100%, 78rem);
    height: calc(100vh - clamp(3rem, 8vw, 6rem));
    max-height: 45.5rem;
}

.login-future-page__panel {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1.08fr) minmax(24rem, 0.92fr);
    width: 100%;
    height: 100%;
    min-height: 0;
    border: 1px solid var(--login-panel-border);
    border-radius: 36px;
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.84), var(--login-panel-bg-soft)),
        var(--login-panel-bg);
    backdrop-filter: blur(20px);
    overflow: hidden;
    animation: loginFutureCardEnter 700ms cubic-bezier(0.16, 1, 0.3, 1);
}

.login-future-page__story,
.login-future-page__auth {
    position: relative;
    min-width: 0;
    padding: clamp(1.5rem, 4vw, 2.8rem);
    overflow: hidden;
}

.login-future-page__story {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0.9rem;
    background:
        linear-gradient(180deg, rgba(250, 252, 254, 0.96), rgba(243, 247, 251, 0.92)),
        radial-gradient(circle at top left, var(--login-brand-soft), transparent 34%);
}

.login-future-page__story::after {
    content: '';
    position: absolute;
    inset: auto auto 2rem 2rem;
    width: 12rem;
    height: 12rem;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(var(--brand-primary-rgb), 0.08), transparent 72%);
    pointer-events: none;
}

.login-future-page__auth {
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid var(--login-panel-border);
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.985), rgba(249, 251, 253, 0.97)),
        var(--login-panel-bg-strong);
}

.login-future-page__story-header,
.login-future-page__story-copy,
.login-future-page__visual,
.login-future-page__quote,
.login-future-page__auth-header,
.login-future-page__auth-inner {
    position: relative;
    z-index: 1;
}

.login-future-page__brand-lockup {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.login-future-page__brand-copy {
    display: flex;
    flex-direction: column;
    gap: 0.55rem;
    min-width: 0;
}

.login-future-page__logo-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 8rem;
    height: 8rem;
    padding: 0.95rem;
    border: 1px solid var(--login-panel-border-strong);
    border-radius: 24px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.99), rgba(248, 250, 252, 0.94));
    animation: loginFuturePulse 7s ease-in-out infinite;
}

.login-future-page__logo {
    width: 100%;
    max-width: 5.2rem;
    max-height: 5.2rem;
    object-fit: contain;
}

.login-future-page__company {
    display: inline-block;
    color: var(--brand-primary);
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
}

.login-future-page__eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    width: fit-content;
    padding: 0.62rem 0.92rem;
    border: 1px solid rgba(var(--brand-primary-rgb), 0.16);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.72);
    color: var(--brand-primary);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    backdrop-filter: blur(12px);
    animation: loginFutureBadgeEnter 700ms cubic-bezier(0.16, 1, 0.3, 1);
}

.login-future-page__eyebrow-dot {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 50%;
    background: #35d0a4;
    box-shadow: 0 0 0 0 rgba(53, 208, 164, 0.4);
    animation: loginFutureSignal 1.8s infinite;
}

.login-future-page__story-copy {
    margin-top: 0;
}

.login-future-page__story-copy h1 {
    margin-bottom: 0.75rem;
    color: var(--login-ink);
    font-size: clamp(1.9rem, 2.7vw, 2.7rem);
    line-height: 1.04;
}

.login-future-page__story-copy p {
    max-width: 33rem;
    margin: 0;
    color: var(--login-muted);
    font-size: 0.94rem;
    line-height: 1.58;
}

.login-future-page__visual {
    position: relative;
    min-height: 0;
    height: clamp(15rem, 29vh, 18rem);
    margin: 0;
    border: 1px solid var(--login-panel-border);
    border-radius: 30px;
    background:
        radial-gradient(circle at 78% 18%, rgba(var(--brand-primary-rgb), 0.05), transparent 24%),
        linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(245, 248, 251, 0.96)),
        rgba(255, 255, 255, 0.9);
    overflow: hidden;
}

.login-future-page__visual-grid {
    position: absolute;
    inset: 0;
    pointer-events: none;
}

.login-future-page__visual-grid {
    background-image:
        linear-gradient(rgba(15, 23, 42, 0.05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(15, 23, 42, 0.05) 1px, transparent 1px);
    background-size: 2.8rem 2.8rem;
    mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.78), transparent 90%);
}

.login-future-page__story-note {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.95rem 1rem;
    border: 1px solid var(--login-panel-border-strong);
    border-radius: 22px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.95), rgba(var(--brand-primary-rgb), 0.05));
}

.login-future-page__story-note-kicker {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    color: var(--brand-primary);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.login-future-page__story-note-icon {
    width: 0.9rem;
    height: 0.9rem;
}

.login-future-page__story-note strong {
    color: var(--login-ink-soft);
    font-size: 0.96rem;
    line-height: 1.35;
}

.login-future-page__story-note p {
    margin: 0;
    color: var(--login-muted);
    font-size: 0.84rem;
    line-height: 1.55;
}

.login-future-page__visual-module {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 10.2rem;
    padding: 0.78rem 0.82rem;
    border: 1px solid transparent;
    border-radius: 18px;
    backdrop-filter: blur(12px);
    animation: loginFutureSignalLift 6s ease-in-out infinite;
}

.login-future-page__visual-module--incident {
    top: 1.15rem;
    left: 1.15rem;
    border-color: rgba(245, 158, 11, 0.16);
    background: linear-gradient(180deg, rgba(255, 250, 239, 0.98), rgba(255, 246, 226, 0.94));
}

.login-future-page__visual-module--breakdown {
    top: 5.95rem;
    right: 1.15rem;
    border-color: rgba(245, 158, 11, 0.16);
    background: linear-gradient(180deg, rgba(255, 249, 235, 0.95), rgba(255, 244, 221, 0.9));
    animation-delay: 1.4s;
}

.login-future-page__visual-module-head {
    display: flex;
    align-items: center;
    gap: 0.62rem;
}

.login-future-page__visual-module-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 2.2rem;
    height: 2.2rem;
    border-radius: 14px;
    font-size: 0.95rem;
}

.login-future-page__visual-module--incident .login-future-page__visual-module-icon {
    background: rgba(245, 158, 11, 0.14);
    color: #d97706;
}

.login-future-page__visual-module--breakdown .login-future-page__visual-module-icon {
    background: rgba(245, 158, 11, 0.14);
    color: #d97706;
}

.login-future-page__visual-module-copy {
    display: flex;
    flex-direction: column;
    gap: 0.16rem;
    min-width: 0;
}

.login-future-page__visual-module-copy span {
    color: var(--login-muted);
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.login-future-page__visual-module-copy strong {
    color: var(--login-ink-soft);
    font-size: 0.78rem;
    line-height: 1.35;
}

.login-future-page__visual-device {
    position: absolute;
    top: 1.15rem;
    right: 1.15rem;
    display: flex;
    flex-direction: column;
    gap: 0.55rem;
    width: 11.25rem;
    padding: 0.9rem 0.95rem;
    border: 1px solid rgba(34, 197, 94, 0.14);
    border-radius: 20px;
    background:
        linear-gradient(180deg, rgba(246, 254, 247, 0.98), rgba(238, 251, 241, 0.94)),
        rgba(255, 255, 255, 0.9);
    animation: loginFutureFloatTwo 11s ease-in-out infinite;
}

.login-future-page__visual-device-head {
    display: flex;
    align-items: center;
    gap: 0.7rem;
}

.login-future-page__visual-device-icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.7rem;
    height: 2.7rem;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.16), rgba(22, 163, 74, 0.12));
    color: #16a34a;
    font-size: 1.15rem;
}

.login-future-page__visual-device-icon::after {
    content: '';
    position: absolute;
    inset: -0.3rem;
    border: 1px dashed rgba(34, 197, 94, 0.24);
    border-radius: 18px;
}

.login-future-page__visual-device-copy {
    display: flex;
    flex-direction: column;
    gap: 0.18rem;
    min-width: 0;
}

.login-future-page__visual-device-copy span {
    color: var(--login-muted);
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.login-future-page__visual-device-copy strong {
    color: var(--login-ink-soft);
    font-size: 0.86rem;
    line-height: 1.35;
}

.login-future-page__visual-device small {
    color: var(--login-muted);
    font-size: 0.72rem;
    line-height: 1.5;
}

.login-future-page__visual-route {
    position: absolute;
    left: 1.2rem;
    right: 1.2rem;
    bottom: 3.45rem;
    height: 4.8rem;
}

.login-future-page__visual-route::before {
    content: '';
    position: absolute;
    left: 1.2rem;
    right: 1.2rem;
    top: 50%;
    height: 0.4rem;
    border-radius: 999px;
    background:
        linear-gradient(90deg, rgba(148, 163, 184, 0.18) 0%, rgba(var(--brand-primary-rgb), 0.24) 50%, rgba(148, 163, 184, 0.18) 100%);
    transform: translateY(-50%);
}

.login-future-page__visual-route::after {
    content: '';
    position: absolute;
    left: 1.8rem;
    right: 1.8rem;
    top: 50%;
    height: 2px;
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.94) 45%, transparent 45%);
    background-size: 1rem 2px;
    transform: translateY(-50%);
    opacity: 0.9;
}

.login-future-page__visual-route-pin {
    position: absolute;
    display: inline-flex;
    top: 50%;
    align-items: center;
    justify-content: center;
    width: 2.3rem;
    height: 2.3rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(var(--brand-primary-rgb), 0.14);
    color: var(--brand-primary);
    font-size: 1.2rem;
    transform: translateY(-50%);
}

.login-future-page__visual-route-pin--origin {
    left: 0;
    border-color: rgba(100, 116, 139, 0.22);
    background: rgba(248, 250, 252, 0.96);
    color: #64748b;
}

.login-future-page__visual-route-pin--destination {
    right: 0;
    border-color: rgba(34, 197, 94, 0.2);
    background: rgba(244, 253, 246, 0.96);
    color: #16a34a;
    animation: loginFutureDestinationBob 2.6s ease-in-out infinite;
}

.login-future-page__visual-route-pin i {
    transform: translateY(3px);
}

.login-future-page__visual-route-label {
    position: absolute;
    bottom: 0;
    color: var(--login-muted-strong);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
}

.login-future-page__visual-route-label--origin {
    left: 0;
}

.login-future-page__visual-route-label--destination {
    right: 0;
}

.login-future-page__visual-truck {
    position: absolute;
    left: 18%;
    top: 50%;
    width: 6.8rem;
    height: 4.7rem;
    transform: translateY(-50%);
    animation: loginFutureTruckDrive 8s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}

.login-future-page__visual-truck-icon {
    position: absolute;
    inset: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    background: transparent;
}

.login-future-page__visual-truck-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0 8px 12px rgba(255, 122, 58, 0.18));
}

.login-future-page__visual-truck-signal {
    position: absolute;
    inset: -0.3rem;
    border-radius: 28px;
    border: 1px solid rgba(255, 122, 58, 0.25);
    animation: loginFutureTrackerPulse 2.4s ease-out infinite;
}

.login-future-page__visual-truck-signal--delay {
    animation-delay: 1s;
}

.login-future-page__quote {
    margin-top: 0;
    padding: 0.95rem 1rem;
    border: 1px solid var(--login-panel-border);
    border-radius: 24px;
    background: var(--login-surface);
}

.login-future-page__quote p {
    margin: 0;
    color: var(--login-ink-soft);
    font-size: 0.88rem;
    line-height: 1.58;
}

.login-future-page__quote-meta {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    margin-top: 1rem;
}

.login-future-page__quote-meta strong {
    color: var(--login-ink);
    font-size: 0.88rem;
}

.login-future-page__quote-meta span {
    color: var(--login-muted);
    font-size: 0.8rem;
}

.login-future-page__auth-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    width: min(100%, 28rem);
    min-height: 100%;
}

.login-future-page__auth-header {
    margin-bottom: 0.15rem;
    display: flex;
    justify-content: center;
    text-align: center;
}

.login-future-page__auth-header .login-future-page__brand-lockup {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.7rem;
    width: 100%;
}

.login-future-page__auth-header .login-future-page__logo-wrap {
    width: 6.4rem;
    height: 6.4rem;
    padding: 0.8rem;
    border-radius: 22px;
}

.login-future-page__auth-header .login-future-page__logo {
    max-width: 5rem;
    max-height: 5rem;
}

.login-future-page__auth-header .login-future-page__brand-copy {
    align-items: center;
    text-align: center;
    gap: 0.4rem;
}

.login-future-page__auth-header .login-future-page__company {
    font-size: 0.72rem;
    letter-spacing: 0.2em;
}

.login-future-page__auth-header .login-future-page__eyebrow {
    padding: 0.5rem 0.78rem;
    font-size: 0.66rem;
    letter-spacing: 0.14em;
}

.login-future-page__auth-copy {
    margin-bottom: 0.9rem;
}

.login-future-page__auth-kicker {
    display: inline-block;
    margin-bottom: 0.8rem;
    color: var(--login-muted);
    font-size: 0.9rem;
    font-weight: 500;
}

.login-future-page__auth-copy h2 {
    margin-bottom: 0.7rem;
    color: var(--login-ink);
    font-size: clamp(1.8rem, 2.45vw, 2.35rem);
    line-height: 1.05;
}

.login-future-page__auth-copy p {
    margin-bottom: 0;
    color: var(--login-muted);
    font-size: 0.9rem;
    line-height: 1.55;
}

.login-future-page__form {
    padding: 0;
}

.login-future-page__field {
    margin-bottom: 0.85rem !important;
}

.login-future-page__label {
    display: inline-flex;
    align-items: center;
    margin-bottom: 0.5rem;
    color: var(--login-muted-strong);
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.login-future-page .form-control.login-future-page__input-control {
    min-height: 3rem;
    padding: 0.72rem 0.95rem;
    border: 1px solid rgba(148, 163, 184, 0.26) !important;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.98) !important;
    color: var(--login-ink) !important;
}

.login-future-page .form-control.login-future-page__input-control::placeholder {
    color: rgba(98, 118, 142, 0.72);
}

.login-future-page .form-control.login-future-page__input-control:focus {
    border-color: rgba(var(--brand-primary-rgb), 0.4) !important;
    background: rgba(255, 255, 255, 0.98) !important;
}

.login-future-page .form-group-with-icon .form-control-feedback {
    right: 0.5rem;
    color: rgba(98, 118, 142, 0.78);
}

.login-future-page .validation-error {
    color: #d84d4d !important;
}

.login-future-page__form-support {
    display: flex;
    justify-content: flex-end;
    margin: 0 0 0.85rem;
}

.login-future-page__recaptcha {
    margin-bottom: 0.9rem !important;
}

.login-future-page__submit {
    position: relative;
    min-height: 3.1rem;
    border: 0 !important;
    border-radius: 18px;
    background-image: linear-gradient(135deg, var(--brand-primary), var(--brand-gradient-end)) !important;
    font-size: 0.92rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    overflow: hidden;
}

.login-future-page__submit::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg, transparent 20%, rgba(255, 255, 255, 0.22) 50%, transparent 80%);
    transform: translateX(-120%);
    animation: loginFutureButtonSweep 4.4s ease-in-out infinite;
}

.login-future-page__forgot {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0;
    border-radius: 999px;
    color: var(--login-muted-strong);
    font-size: 0.88rem;
    font-weight: 600;
    text-decoration: none !important;
    transition: color 180ms ease, transform 180ms ease;
}

.login-future-page__forgot:hover {
    color: var(--brand-primary-hover);
    transform: translateY(-1px);
}

.login-future-page__copyright {
    margin: auto 0 0;
    padding-top: 1rem;
    color: rgba(98, 118, 142, 0.74);
    font-size: 0.8rem;
    text-align: left;
}

@keyframes loginFutureCardEnter {
    0% {
        opacity: 0;
        transform: translateY(20px) scale(0.98);
    }

    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes loginFutureBadgeEnter {
    0% {
        opacity: 0;
        transform: translateY(-10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes loginFutureGridShift {
    0% {
        transform: translate3d(0, 0, 0);
    }

    50% {
        transform: translate3d(0, -1rem, 0);
    }

    100% {
        transform: translate3d(0, 0, 0);
    }
}

@keyframes loginFutureFloatOne {
    0%, 100% {
        transform: translate3d(0, 0, 0);
    }

    50% {
        transform: translate3d(1rem, -1rem, 0);
    }
}

@keyframes loginFutureFloatTwo {
    0%, 100% {
        transform: translate3d(0, 0, 0);
    }

    50% {
        transform: translate3d(-0.85rem, 1rem, 0);
    }
}

@keyframes loginFuturePulse {
    0%, 100% {
        transform: scale(1);
        opacity: 0.72;
    }

    50% {
        transform: scale(1.06);
        opacity: 1;
    }
}

@keyframes loginFutureSignal {
    0% {
        box-shadow: 0 0 0 0 rgba(53, 208, 164, 0.36);
    }

    70% {
        box-shadow: 0 0 0 12px rgba(53, 208, 164, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(53, 208, 164, 0);
    }
}

@keyframes loginFutureSignalLift {
    0%, 100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-3px);
    }
}

@keyframes loginFutureTruckDrive {
    0% {
        transform: translate(0, -50%);
    }

    50% {
        transform: translate(10.8rem, -50%);
    }

    100% {
        transform: translate(0, -50%);
    }
}

@keyframes loginFutureTrackerPulse {
    0% {
        transform: scale(0.82);
        opacity: 0.85;
    }

    70% {
        transform: scale(1.18);
        opacity: 0;
    }

    100% {
        transform: scale(1.18);
        opacity: 0;
    }
}

@keyframes loginFutureDestinationBob {
    0%, 100% {
        transform: translateY(-50%);
    }

    50% {
        transform: translateY(calc(-50% - 5px));
    }
}

@keyframes loginFutureButtonSweep {
    0%, 55% {
        transform: translateX(-120%);
    }

    85%, 100% {
        transform: translateX(120%);
    }
}

@media (max-width: 767px) {
    .login-future-page {
        height: auto;
        padding: 1rem;
        overflow-y: auto;
    }

    .login-future-page__shell {
        height: auto;
        max-height: none;
    }

    .login-future-page__panel {
        border-radius: 24px;
        height: auto;
    }

    .login-future-page__story,
    .login-future-page__auth {
        padding: 1.25rem;
    }

    .login-future-page__brand-lockup {
        align-items: center;
    }

    .login-future-page__auth-header .login-future-page__logo-wrap {
        width: 5.25rem;
        height: 5.25rem;
        border-radius: 18px;
    }

    .login-future-page__auth-header .login-future-page__logo {
        max-width: 4.1rem;
        max-height: 4.1rem;
    }

    .login-future-page__logo-wrap {
        width: 5.6rem;
        height: 5.6rem;
        border-radius: 20px;
    }

    .login-future-page__story-copy h1 {
        font-size: 1.8rem;
    }

    .login-future-page__visual {
        height: 17rem;
    }

    .login-future-page__visual-device {
        top: 1rem;
        right: 0.9rem;
        width: 10.1rem;
    }

    .login-future-page__visual-module {
        width: 9.1rem;
        padding: 0.72rem 0.76rem;
    }

    .login-future-page__visual-module--incident {
        top: 1rem;
        left: 0.9rem;
    }

    .login-future-page__visual-module--breakdown {
        top: 5.6rem;
        right: 0.9rem;
    }

    .login-future-page__story-note {
        padding: 0.85rem 0.9rem;
    }

    .login-future-page__auth-copy h2 {
        font-size: 2rem;
    }
}

@media (max-width: 991px) {
    .login-future-page {
        height: auto;
        overflow-y: auto;
    }

    .login-future-page__shell {
        height: auto;
        max-height: none;
    }

    .login-future-page__panel {
        grid-template-columns: minmax(0, 1fr);
        height: auto;
    }

    .login-future-page__auth {
        order: -1;
        border-left: 0;
        border-bottom: 1px solid rgba(var(--brand-primary-rgb), 0.12);
    }

    .login-future-page__story::after {
        display: none;
    }

    .login-future-page__auth-inner {
        gap: 0.9rem;
    }
}

@media (prefers-reduced-motion: reduce) {
    .login-future-page *,
    .login-future-page *::before,
    .login-future-page *::after {
        animation: none !important;
        transition: none !important;
    }
}
</style>
